<div
  class="text-typed-train-bottom-stack"
  [class.position-absolute]="!hasFrontMedia()"
  [class.text-typed-train-bottom-stack--absolute]="!hasFrontMedia()"
  [class.text-typed-train-bottom-stack--flow]="hasFrontMedia()"
>
  @if (isBackVisible()) {
    <div class="text-typed-train-answer text-center">
      <strong>{{ card().backText || t()["train.noAnswerText"] }}</strong>
      @if (card().explanation) {
        <p>{{ card().explanation }}</p>
      }
    </div>
  }

  <div
    class="text-typed-train-input input-group bg-body"
    [class.text-typed-train-input-correct]="
      isBackVisible() && isCorrect() === true
    "
    [class.text-typed-train-input-incorrect]="
      isBackVisible() && isCorrect() === false
    "
  >
    <input
      type="text"
      [attr.maxlength]="maxAnswerLength"
      [attr.aria-invalid]="isAnswerTooLong() ? 'true' : null"
      [attr.aria-describedby]="
        isAnswerTooLong() ? 'training-answer-limit' : null
      "
      class="form-control border-0"
      data-testid="training-typed-answer"
      [attr.lang]="inputLang() || null"
      [attr.aria-label]="
        isBackVisible()
          ? isCorrect()
            ? t()['train.correctAnswer']
            : isCorrect() === false
              ? t()['train.incorrectAnswer']
              : t()['train.expectedAnswer']
          : t()['train.typeAnswer']
      "
      [placeholder]="t()['train.typeAnswer']"
      [spellcheck]="inputSpellcheckEnabled()"
      [readOnly]="isBackVisible()"
      [value]="userAnswer()"
      (input)="onAnswerInput($event)"
      (keydown.enter)="continueAnswer()"
    />

    <button
      type="button"
      class="text-typed-train-microphone btn btn-icon btn-outline-primary rounded-circle waves-effect align-self-center me-3"
      [attr.aria-label]="t()['train.microphone']"
      [title]="t()['train.microphone']"
      tabindex="-1"
    >
      <svg class="sa-icon sa-icon-2x sa-bold sa-nofill" aria-hidden="true">
        <use href="/assets/icons/sprite.svg#mic"></use>
      </svg>
    </button>
  </div>
  @if (isAnswerTooLong()) {
    <p id="training-answer-limit" class="text-danger mb-0" role="alert">
      {{ t()["train.answerTooLong"] }}
    </p>
  }
</div>
